import dayjs from 'dayjs';
function getDisabledState(_ref) {
  var maxDate = _ref.maxDate,
    minDate = _ref.minDate,
    month = _ref.month,
    amountOfMonths = _ref.amountOfMonths;
  var nextDisabled = maxDate instanceof Date && dayjs(month).add(amountOfMonths - 1, "month").endOf("month").isAfter(dayjs(maxDate).endOf("day").subtract(1, "minute"));
  var previousDisabled = minDate instanceof Date && dayjs(month).startOf("month").isBefore(dayjs(minDate).startOf("day").add(1, "minute"));
  return {
    nextDisabled: nextDisabled,
    previousDisabled: previousDisabled
  };
}
export { getDisabledState };